import { Box, Stack } from "@mui/material";
import { LoadMoreButton } from "Components/Affiliate/Stats/LoadMoreButton";
import { RewardsList } from "Components/Loyalty/Shared/Rewards/RewardsList/RewardsList";
import { RewardsSkeleton } from "Components/Loyalty/Shared/Rewards/RewardsSkeleton";
import type { RewardEntry } from "Components/Loyalty/Shared/Rewards/types";
import { SectionTitle } from "Components/Loyalty/Shared/SectionTitle/SectionTitle";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  title: string;
  pointsLabel: string;
  items: Array<RewardEntry> | undefined;
  isLoading: boolean;
  isError: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
};

export const Rewards = ({
  title,
  pointsLabel,
  items,
  isLoading,
  isError,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: Props) => {
  const { t } = useResource();

  if (isLoading) {
    return <RewardsSkeleton title={title} pointsLabel={pointsLabel} />;
  }

  if (isError || !items) {
    return (
      <Stack gap={4}>
        <SectionTitle>{title}</SectionTitle>
        <ErrorText>{t(Resources.Error.Error)}</ErrorText>
      </Stack>
    );
  }

  return (
    <Stack gap={4}>
      <SectionTitle>{title}</SectionTitle>
      <RewardsList items={items} pointsLabel={pointsLabel} />
      <Box mt={3}>
        <LoadMoreButton
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
        />
      </Box>
    </Stack>
  );
};
